/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Properties_Max_WidthInputs */

const en_tables_custom_properties_max_width = /** @type {(inputs: Tables_Custom_Properties_Max_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties Max Width`)
};

const de_tables_custom_properties_max_width = /** @type {(inputs: Tables_Custom_Properties_Max_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max Breite`)
};

/**
* | output |
* | --- |
* | "Properties Max Width" |
*
* @param {Tables_Custom_Properties_Max_WidthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_properties_max_width = /** @type {((inputs?: Tables_Custom_Properties_Max_WidthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Properties_Max_WidthInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_properties_max_width(inputs)
	return de_tables_custom_properties_max_width(inputs)
});